var map = {
	"./collection-diamondJewelry025Carat@2x.webp": 1312,
	"./collection-diamondJewelry050Carat@2x.webp": 1313,
	"./collection-diamondJewelry070Carat@2x.webp": 1314,
	"./collection-diamondJewelry100Carat@2x.webp": 1315,
	"./collection-diamondJewelry@2x.webp": 1316,
	"./collection-diamondJewelryBestseller@2x.webp": 1317,
	"./collection-diamondJewelryBracelets@2x.webp": 1318,
	"./collection-diamondJewelryBudgetHigh@2x.webp": 1319,
	"./collection-diamondJewelryBudgetLow@2x.webp": 1320,
	"./collection-diamondJewelryBudgetMedium@2x.webp": 1321,
	"./collection-diamondJewelryCollectionRings@2x.webp": 1322,
	"./collection-diamondJewelryColliers@2x.webp": 1323,
	"./collection-diamondJewelryDelicateJewels@2x.webp": 1324,
	"./collection-diamondJewelryEarrings@2x.webp": 1325,
	"./collection-diamondJewelryExclusive@2x.webp": 1326,
	"./collection-diamondJewelryGold@2x.webp": 1327,
	"./collection-diamondJewelryPlatinum@2x.webp": 1328,
	"./collection-diamondJewelryPresentsChristmas@2x.webp": 1329,
	"./collection-diamondJewelryPresentsMother@2x.webp": 1330,
	"./collection-diamondJewelryPresentsValentine@2x.webp": 1331,
	"./collection-diamondJewelryPresentsWomen@2x.webp": 1332,
	"./collection-diamondJewelryPresentsYearly@2x.webp": 1333,
	"./collection-diamondJewelryRedgold@2x.webp": 1334,
	"./collection-diamondJewelryRosegold@2x.webp": 1335,
	"./collection-diamondJewelrySets@2x.webp": 1336,
	"./collection-diamondJewelrySignature@2x.webp": 1337,
	"./collection-diamondJewelrySignet@2x.webp": 1338,
	"./collection-diamondJewelryWhitegold@2x.webp": 1339,
	"./collection-engagementRings025Carat@2x.webp": 1340,
	"./collection-engagementRings050Carat@2x.webp": 1341,
	"./collection-engagementRings070Carat@2x.webp": 1342,
	"./collection-engagementRings100Carat@2x.webp": 1343,
	"./collection-engagementRings@2x.webp": 1344,
	"./collection-engagementRingsBestseller@2x.webp": 1345,
	"./collection-engagementRingsBudgetHigh@2x.webp": 1346,
	"./collection-engagementRingsBudgetLow@2x.webp": 1347,
	"./collection-engagementRingsBudgetMedium@2x.webp": 1348,
	"./collection-engagementRingsCharacter@2x.webp": 1349,
	"./collection-engagementRingsCharisma@2x.webp": 1350,
	"./collection-engagementRingsClassic@2x.webp": 1351,
	"./collection-engagementRingsCollectionRings@2x.webp": 1352,
	"./collection-engagementRingsCordial@2x.webp": 1353,
	"./collection-engagementRingsDainty@2x.webp": 1354,
	"./collection-engagementRingsDiamond@2x.webp": 1355,
	"./collection-engagementRingsDiamonds@2x.webp": 1356,
	"./collection-engagementRingsEntwined@2x.webp": 1357,
	"./collection-engagementRingsEssentials@2x.webp": 1358,
	"./collection-engagementRingsExclusive@2x.webp": 1359,
	"./collection-engagementRingsFancy@2x.webp": 1360,
	"./collection-engagementRingsFastDelivery@2x.webp": 1361,
	"./collection-engagementRingsGold@2x.webp": 1362,
	"./collection-engagementRingsHalo@2x.webp": 1363,
	"./collection-engagementRingsHeart@2x.webp": 1364,
	"./collection-engagementRingsLabGrownDiamonds@2x.webp": 1365,
	"./collection-engagementRingsModern@2x.webp": 1366,
	"./collection-engagementRingsPlatinum@2x.webp": 1367,
	"./collection-engagementRingsPrincess@2x.webp": 1368,
	"./collection-engagementRingsRedgold@2x.webp": 1369,
	"./collection-engagementRingsRingsets@2x.webp": 1370,
	"./collection-engagementRingsRosegold@2x.webp": 1371,
	"./collection-engagementRingsSignature@2x.webp": 1372,
	"./collection-engagementRingsSolitaire@2x.webp": 1373,
	"./collection-engagementRingsTensionRing@2x.webp": 1374,
	"./collection-engagementRingsUsa@2x.webp": 1375,
	"./collection-engagementRingsVintage@2x.webp": 1376,
	"./collection-engagementRingsWhitegold@2x.webp": 1377,
	"./collection-memoireRings@2x.webp": 1378,
	"./collection-memoireRingsAsWeddingRings@2x.webp": 1379,
	"./collection-memoireRingsBestseller@2x.webp": 1380,
	"./collection-memoireRingsBudgetHigh@2x.webp": 1381,
	"./collection-memoireRingsBudgetLow@2x.webp": 1382,
	"./collection-memoireRingsBudgetMedium@2x.webp": 1383,
	"./collection-memoireRingsCheap@2x.webp": 1384,
	"./collection-memoireRingsColored@2x.webp": 1385,
	"./collection-memoireRingsConfigurator@2x.webp": 1386,
	"./collection-memoireRingsExclusive@2x.webp": 1387,
	"./collection-memoireRingsFullSizeMemoires@2x.webp": 1388,
	"./collection-memoireRingsGold@2x.webp": 1389,
	"./collection-memoireRingsGrowingMemoires@2x.webp": 1390,
	"./collection-memoireRingsHalfSetMemories@2x.webp": 1391,
	"./collection-memoireRingsPlatinum@2x.webp": 1392,
	"./collection-memoireRingsRedgold@2x.webp": 1393,
	"./collection-memoireRingsRingsets@2x.webp": 1394,
	"./collection-memoireRingsRosegold@2x.webp": 1395,
	"./collection-memoireRingsSignature@2x.webp": 1396,
	"./collection-memoireRingsSlim@2x.webp": 1397,
	"./collection-memoireRingsWhite@2x.webp": 1398,
	"./collection-weddingRings@2x.webp": 1399,
	"./collection-weddingRingsBestseller@2x.webp": 1400,
	"./collection-weddingRingsBlack@2x.webp": 1401,
	"./collection-weddingRingsBudgetHigh@2x.webp": 1402,
	"./collection-weddingRingsBudgetLow@2x.webp": 1403,
	"./collection-weddingRingsBudgetMedium@2x.webp": 1404,
	"./collection-weddingRingsCarbon@2x.webp": 1405,
	"./collection-weddingRingsCeramic@2x.webp": 1406,
	"./collection-weddingRingsCertificate@2x.webp": 1407,
	"./collection-weddingRingsCheap@2x.webp": 1408,
	"./collection-weddingRingsClassic@2x.webp": 1409,
	"./collection-weddingRingsCrown@2x.webp": 1410,
	"./collection-weddingRingsDiamonds@2x.webp": 1411,
	"./collection-weddingRingsExclusive@2x.webp": 1412,
	"./collection-weddingRingsFacetes@2x.webp": 1413,
	"./collection-weddingRingsFacettedConnections@2x.webp": 1414,
	"./collection-weddingRingsFancy@2x.webp": 1415,
	"./collection-weddingRingsFinishes@2x.webp": 1416,
	"./collection-weddingRingsForestGreen@2x.webp": 1417,
	"./collection-weddingRingsFrameSettings@2x.webp": 1418,
	"./collection-weddingRingsGayLesbianCouples@2x.webp": 1419,
	"./collection-weddingRingsGold@2x.webp": 1420,
	"./collection-weddingRingsHammered@2x.webp": 1421,
	"./collection-weddingRingsHearts@2x.webp": 1422,
	"./collection-weddingRingsMen@2x.webp": 1423,
	"./collection-weddingRingsMillgrif@2x.webp": 1424,
	"./collection-weddingRingsModern@2x.webp": 1425,
	"./collection-weddingRingsMokumeGane@2x.webp": 1426,
	"./collection-weddingRingsMorningGlow@2x.webp": 1427,
	"./collection-weddingRingsMulticolor@2x.webp": 1428,
	"./collection-weddingRingsNaturalBeige@2x.webp": 1429,
	"./collection-weddingRingsPalladium@2x.webp": 1430,
	"./collection-weddingRingsPlain@2x.webp": 1431,
	"./collection-weddingRingsPlatinum@2x.webp": 1432,
	"./collection-weddingRingsPolar@2x.webp": 1433,
	"./collection-weddingRingsRedgold@2x.webp": 1434,
	"./collection-weddingRingsRingSets@2x.webp": 1435,
	"./collection-weddingRingsRosegold@2x.webp": 1436,
	"./collection-weddingRingsSecretHeart@2x.webp": 1437,
	"./collection-weddingRingsSignature@2x.webp": 1438,
	"./collection-weddingRingsSlim@2x.webp": 1439,
	"./collection-weddingRingsStackingRings@2x.webp": 1440,
	"./collection-weddingRingsStarrySky@2x.webp": 1441,
	"./collection-weddingRingsStylesCool@2x.webp": 1442,
	"./collection-weddingRingsStylesCreative@2x.webp": 1443,
	"./collection-weddingRingsStylesElegant@2x.webp": 1444,
	"./collection-weddingRingsStylesLuxury@2x.webp": 1445,
	"./collection-weddingRingsStylesNatural@2x.webp": 1446,
	"./collection-weddingRingsStylesRomantic@2x.webp": 1447,
	"./collection-weddingRingsStylesUrban@2x.webp": 1448,
	"./collection-weddingRingsTensionRings@2x.webp": 1449,
	"./collection-weddingRingsTwoColors@2x.webp": 1450,
	"./collection-weddingRingsWaveDesign@2x.webp": 1451,
	"./collection-weddingRingsWhitegold@2x.webp": 1452,
	"./collection-weddingRingsWomen@2x.webp": 1453,
	"./collection-weddingRingstrisets@2x.webp": 1454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1799;